var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15.375H15C15.2071 15.375 15.375 15.2071 15.375 15V5.87132C15.375 5.77186 15.3355 5.67648 15.2652 5.60616L12.3938 2.73483C12.3235 2.66451 12.2281 2.625 12.1287 2.625H7.5C7.29289 2.625 7.125 2.79289 7.125 3V15C7.125 15.2071 7.29289 15.375 7.5 15.375ZM15 16.5H7.5C6.67157 16.5 6 15.8284 6 15V3C6 2.17157 6.67157 1.5 7.5 1.5H12.1287C12.5265 1.5 12.908 1.65804 13.1893 1.93934L16.0607 4.81066C16.342 5.09197 16.5 5.4735 16.5 5.87132V15C16.5 15.8284 15.8284 16.5 15 16.5Z",
    fill: "#11CA72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4375 8.25C11.4375 7.93934 11.6893 7.6875 12 7.6875H13.875C14.1857 7.6875 14.4375 7.93934 14.4375 8.25C14.4375 8.56066 14.1857 8.8125 13.875 8.8125H12C11.6893 8.8125 11.4375 8.56066 11.4375 8.25Z",
    fill: "#11CA72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4375 10.5C11.4375 10.1893 11.6893 9.9375 12 9.9375H13.875C14.1857 9.9375 14.4375 10.1893 14.4375 10.5C14.4375 10.8107 14.1857 11.0625 13.875 11.0625H12C11.6893 11.0625 11.4375 10.8107 11.4375 10.5Z",
    fill: "#11CA72"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 4.5,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#11CA72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18804 6.28203C4.44653 6.10971 4.79576 6.17956 4.96809 6.43804L6.00006 7.986L7.03203 6.43804C7.20435 6.17956 7.55359 6.10971 7.81208 6.28203C8.07056 6.45435 8.14041 6.80359 7.96809 7.06208L6.6761 9.00006L7.96809 10.938C8.14041 11.1965 8.07056 11.5458 7.81208 11.7181C7.55359 11.8904 7.20435 11.8206 7.03203 11.5621L6.00006 10.0141L4.96809 11.5621C4.79576 11.8206 4.44653 11.8904 4.18804 11.7181C3.92956 11.5458 3.85971 11.1965 4.03203 10.938L5.32402 9.00006L4.03203 7.06208C3.85971 6.80359 3.92956 6.45435 4.18804 6.28203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel_icon.d19aebee23ee068e070d1046df15b833.svg";
export { ForwardRef as ReactComponent };